/* =============================================
   SCORPIUS BUY-BACK CALCULATOR
   Mirrors live site: bulk sell + bulk buy
   ============================================= */

(function(){
  'use strict';

  // Fallback price table — used only if no metaobjects are configured.
  // Live prices come from Shopify Admin -> Content -> Metaobjects (buyback_price),
  // emitted as window.SCORPIUS_PRICES by snippets/buyback-prices.liquid.
  // {model: {grade: price}}
  var DEFAULT_BUY_BACK = {
    'iPhone 15 Pro Max': { 'A+': 879, 'A': 799, 'B': 649, 'C': 449, 'D': 200 },
    'iPhone 15 Pro':     { 'A+': 749, 'A': 679, 'B': 549, 'C': 379, 'D': 170 },
    'iPhone 15':         { 'A+': 599, 'A': 539, 'B': 439, 'C': 299, 'D': 130 },
    'iPhone 14 Pro Max': { 'A+': 699, 'A': 629, 'B': 509, 'C': 349, 'D': 150 },
    'iPhone 14 Pro':     { 'A+': 599, 'A': 539, 'B': 439, 'C': 299, 'D': 130 },
    'iPhone 14':         { 'A+': 469, 'A': 419, 'B': 339, 'C': 229, 'D': 100 },
    'iPhone 13 Pro Max': { 'A+': 549, 'A': 489, 'B': 399, 'C': 269, 'D': 110 },
    'iPhone 13 Pro':     { 'A+': 469, 'A': 419, 'B': 339, 'C': 229, 'D': 95 },
    'iPhone 13':         { 'A+': 369, 'A': 329, 'B': 259, 'C': 169, 'D': 70 },
    'iPhone 12 Pro Max': { 'A+': 419, 'A': 379, 'B': 309, 'C': 209, 'D': 80 },
    'iPhone 12 Pro':     { 'A+': 349, 'A': 309, 'B': 249, 'C': 159, 'D': 65 },
    'iPhone 12':         { 'A+': 279, 'A': 249, 'B': 199, 'C': 129, 'D': 50 },
    'iPhone 11 Pro Max': { 'A+': 319, 'A': 279, 'B': 219, 'C': 139, 'D': 55 },
    'iPhone 11':         { 'A+': 209, 'A': 179, 'B': 139, 'C': 89, 'D': 35 },
    'Galaxy S24 Ultra':  { 'A+': 729, 'A': 649, 'B': 529, 'C': 359, 'D': 150 },
    'Galaxy S24+':       { 'A+': 589, 'A': 519, 'B': 419, 'C': 279, 'D': 110 },
    'Galaxy S24':        { 'A+': 449, 'A': 399, 'B': 319, 'C': 209, 'D': 85 },
    'Galaxy S23 Ultra':  { 'A+': 599, 'A': 539, 'B': 429, 'C': 289, 'D': 115 },
    'Galaxy S23':        { 'A+': 379, 'A': 339, 'B': 269, 'C': 179, 'D': 70 },
    'Galaxy S22':        { 'A+': 299, 'A': 269, 'B': 209, 'C': 139, 'D': 55 },
    'Galaxy Z Fold 5':   { 'A+': 879, 'A': 799, 'B': 649, 'C': 449, 'D': 180 },
    'Pixel 8 Pro':       { 'A+': 519, 'A': 459, 'B': 369, 'C': 249, 'D': 100 },
    'Pixel 8':           { 'A+': 379, 'A': 339, 'B': 269, 'C': 179, 'D': 70 },
    'Pixel 7 Pro':       { 'A+': 339, 'A': 299, 'B': 239, 'C': 159, 'D': 60 },
    'Pixel 7':           { 'A+': 239, 'A': 209, 'B': 169, 'C': 109, 'D': 45 }
  };

  // Upgrade unit prices fallback (used only if no upgrade_price metaobjects exist)
  var DEFAULT_UPGRADE = {
    'iPhone 15 Pro Max 256GB': 1049,
    'iPhone 15 Pro 256GB': 899,
    'iPhone 15 128GB': 749,
    'iPhone 14 Pro Max 256GB': 849,
    'iPhone 14 Pro 256GB': 749,
    'iPhone 14 128GB': 599,
    'iPhone 13 Pro Max 256GB': 699,
    'iPhone 13 128GB': 499,
    'iPhone 12 64GB': 369,
    'Galaxy S24 Ultra 256GB': 879,
    'Galaxy S24 128GB': 549,
    'Galaxy S23 256GB': 479,
    'Galaxy S22 128GB': 399,
    'Pixel 8 Pro 128GB': 649,
    'Pixel 8 128GB': 479,
    'iPad Pro 12.9 (2022)': 899,
    'iPad Air (2022)': 549,
    'MacBook Air M2 256GB': 949
  };

  // Resolve live prices: admin metaobjects (window.SCORPIUS_PRICES) win,
  // otherwise fall back to the defaults above. Entries are sorted by their
  // "position" field so the merchant controls dropdown order from the admin.
  // Exposed on window so the PDP trade-in widget and fleet ROI calculator
  // share the same numbers.
  function buildBuyback(list){
    var obj = {};
    (list || []).slice().sort(function(a, b){ return (a.o || 999) - (b.o || 999); })
      .forEach(function(e){
        if (!e.m) return;
        obj[e.m] = { 'A+': e.p[0], 'A': e.p[1], 'B': e.p[2], 'C': e.p[3], 'D': e.p[4] };
      });
    return obj;
  }
  function buildUpgrade(list){
    var obj = {};
    (list || []).slice().sort(function(a, b){ return (a.o || 999) - (b.o || 999); })
      .forEach(function(e){ if (e.m) obj[e.m] = e.p; });
    return obj;
  }
  var SP = window.SCORPIUS_PRICES || {};
  var bbLive = buildBuyback(SP.buyback_list);
  var upLive = buildUpgrade(SP.upgrade_list);
  var BUY_BACK_PRICES = window.BUY_BACK_PRICES = Object.keys(bbLive).length ? bbLive : DEFAULT_BUY_BACK;
  var UPGRADE_PRICES = window.UPGRADE_PRICES = Object.keys(upLive).length ? upLive : DEFAULT_UPGRADE;

  var GRADES = [
    { value: 'A+', label: 'A+ Like new, fully functional' },
    { value: 'A',  label: 'A — Minor scratches, fully functional' },
    { value: 'B',  label: 'B — Obvious wear, fully functional' },
    { value: 'C',  label: 'C — Heavy wear, fully functional' },
    { value: 'D',  label: 'D — Broken / non-functional' }
  ];

  var VAT = 0.20;

  // -------- Sell calculator --------
  function makeOptionList(items, blank){
    var opts = '<option value="">' + (blank || 'Select…') + '</option>';
    items.forEach(function(it){
      opts += '<option value="' + it + '">' + it + '</option>';
    });
    return opts;
  }

  function sellRow(){
    var models = Object.keys(BUY_BACK_PRICES);
    var grades = GRADES.map(function(g){ return '<option value="' + g.value + '">' + g.label + '</option>'; }).join('');
    return '<tr class="calc-row" data-row="sell">' +
      '<td><select class="calc-select calc-model">' + makeOptionList(models, 'Choose model') + '</select></td>' +
      '<td><select class="calc-select calc-grade"><option value="">Grade</option>' + grades + '</select></td>' +
      '<td><input type="number" class="calc-input calc-qty" min="1" value="1"></td>' +
      '<td class="calc-unit">£0.00</td>' +
      '<td class="calc-total">£0.00</td>' +
      '<td><button type="button" class="calc-row-remove" aria-label="Remove row"><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg></button></td>' +
      '</tr>';
  }

  function buyRow(){
    var models = Object.keys(UPGRADE_PRICES);
    return '<tr class="calc-row" data-row="buy">' +
      '<td><select class="calc-select calc-model">' + makeOptionList(models, 'Choose model') + '</select></td>' +
      '<td><input type="number" class="calc-input calc-qty" min="1" value="1"></td>' +
      '<td class="calc-unit">£0.00</td>' +
      '<td class="calc-total">£0.00</td>' +
      '<td><button type="button" class="calc-row-remove" aria-label="Remove row"><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg></button></td>' +
      '</tr>';
  }

  function fmt(n){ return '£' + Number(n).toFixed(2); }

  function recalc(scope){
    var totalBuyBack = 0;
    var subtotalUpgrades = 0;
    document.querySelectorAll('[data-row="sell"]').forEach(function(row){
      var model = row.querySelector('.calc-model').value;
      var grade = row.querySelector('.calc-grade').value;
      var qty = Math.max(1, parseInt(row.querySelector('.calc-qty').value, 10) || 1);
      var unit = (BUY_BACK_PRICES[model] && BUY_BACK_PRICES[model][grade]) || 0;
      var line = unit * qty;
      row.querySelector('.calc-unit').textContent = fmt(unit);
      row.querySelector('.calc-total').textContent = fmt(line);
      totalBuyBack += line;
    });
    document.querySelectorAll('[data-row="buy"]').forEach(function(row){
      var model = row.querySelector('.calc-model').value;
      var qty = Math.max(1, parseInt(row.querySelector('.calc-qty').value, 10) || 1);
      var unit = UPGRADE_PRICES[model] || 0;
      var line = unit * qty;
      row.querySelector('.calc-unit').textContent = fmt(unit);
      row.querySelector('.calc-total').textContent = fmt(line);
      subtotalUpgrades += line;
    });
    var vat = subtotalUpgrades * VAT;
    var totalUpgrades = subtotalUpgrades + vat;
    var net = totalUpgrades - totalBuyBack;

    set('total-buyback', fmt(totalBuyBack));
    set('subtotal-upgrades', fmt(subtotalUpgrades));
    set('vat-upgrades', fmt(vat));
    set('total-upgrades', fmt(totalUpgrades));
    var netEl = document.getElementById('net-to-pay');
    if(netEl){
      netEl.textContent = fmt(Math.abs(net)) + (net < 0 ? ' (credit)' : '');
      netEl.classList.toggle('calc-net-negative', net < 0);
      netEl.classList.toggle('calc-net-positive', net > 0);
    }
  }
  function set(id, v){ var el = document.getElementById(id); if(el) el.textContent = v; }

  function init(){
    var sellTable = document.getElementById('calc-sell-rows');
    var buyTable = document.getElementById('calc-buy-rows');
    var addSell = document.getElementById('calc-add-sell');
    var addBuy = document.getElementById('calc-add-buy');

    function attachRow(row){
      row.querySelectorAll('select, input').forEach(function(el){
        el.addEventListener('change', recalc);
        el.addEventListener('input', recalc);
      });
      var rm = row.querySelector('.calc-row-remove');
      if(rm) rm.addEventListener('click', function(){ row.remove(); recalc(); });
    }

    if(sellTable){
      // start with 3 rows
      for(var i = 0; i < 3; i++){ sellTable.insertAdjacentHTML('beforeend', sellRow()); }
      sellTable.querySelectorAll('tr').forEach(attachRow);
    }
    if(buyTable){
      for(var j = 0; j < 2; j++){ buyTable.insertAdjacentHTML('beforeend', buyRow()); }
      buyTable.querySelectorAll('tr').forEach(attachRow);
    }
    if(addSell) addSell.addEventListener('click', function(){
      sellTable.insertAdjacentHTML('beforeend', sellRow());
      attachRow(sellTable.lastElementChild);
      recalc();
    });
    if(addBuy) addBuy.addEventListener('click', function(){
      buyTable.insertAdjacentHTML('beforeend', buyRow());
      attachRow(buyTable.lastElementChild);
      recalc();
    });

    // Tab switching
    document.querySelectorAll('.calc-tab').forEach(function(tab){
      tab.addEventListener('click', function(){
        document.querySelectorAll('.calc-tab').forEach(function(t){ t.classList.remove('active'); });
        document.querySelectorAll('.calc-panel').forEach(function(p){ p.classList.remove('active'); });
        tab.classList.add('active');
        var panel = document.getElementById(tab.dataset.target);
        if(panel) panel.classList.add('active');
      });
    });

    // Export CSV
    var exportBtn = document.getElementById('calc-export');
    if(exportBtn) exportBtn.addEventListener('click', function(){
      var lines = ['Section,Model,Grade,Quantity,Unit Price,Line Total'];
      document.querySelectorAll('[data-row="sell"]').forEach(function(row){
        var model = row.querySelector('.calc-model').value;
        var grade = row.querySelector('.calc-grade').value;
        var qty = row.querySelector('.calc-qty').value;
        var unit = row.querySelector('.calc-unit').textContent;
        var total = row.querySelector('.calc-total').textContent;
        if(model) lines.push(['Buy-Back', model, grade, qty, unit, total].join(','));
      });
      document.querySelectorAll('[data-row="buy"]').forEach(function(row){
        var model = row.querySelector('.calc-model').value;
        var qty = row.querySelector('.calc-qty').value;
        var unit = row.querySelector('.calc-unit').textContent;
        var total = row.querySelector('.calc-total').textContent;
        if(model) lines.push(['Upgrade', model, '-', qty, unit, total].join(','));
      });
      lines.push('');
      lines.push('Total Buy-Back,' + document.getElementById('total-buyback').textContent);
      lines.push('Subtotal Upgrades,' + document.getElementById('subtotal-upgrades').textContent);
      lines.push('VAT 20%,' + document.getElementById('vat-upgrades').textContent);
      lines.push('Total Upgrades,' + document.getElementById('total-upgrades').textContent);
      lines.push('Net to Pay,' + document.getElementById('net-to-pay').textContent);

      var blob = new Blob([lines.join('\n')], { type: 'text/csv' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = 'scorpius-quote-' + Date.now() + '.csv';
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    });

    // Send quote — saves quote to sessionStorage then opens the contact page,
    // where the contact-form section auto-fills the message field.
    var sendBtn = document.getElementById('calc-send');
    if(sendBtn) sendBtn.addEventListener('click', function(){
      var summary = [];
      summary.push('Quote from Scorpius calculator');
      summary.push('');
      summary.push('--- BUY-BACK ---');
      var hasSell = false;
      document.querySelectorAll('[data-row="sell"]').forEach(function(row){
        var model = row.querySelector('.calc-model').value;
        if(!model) return;
        hasSell = true;
        summary.push((row.querySelector('.calc-qty').value) + ' × ' + model + ' (Grade ' + row.querySelector('.calc-grade').value + ') = ' + row.querySelector('.calc-total').textContent);
      });
      if(!hasSell) summary.push('(none selected)');
      summary.push('');
      summary.push('--- UPGRADES ---');
      var hasBuy = false;
      document.querySelectorAll('[data-row="buy"]').forEach(function(row){
        var model = row.querySelector('.calc-model').value;
        if(!model) return;
        hasBuy = true;
        summary.push((row.querySelector('.calc-qty').value) + ' × ' + model + ' = ' + row.querySelector('.calc-total').textContent);
      });
      if(!hasBuy) summary.push('(none selected)');
      summary.push('');
      summary.push('Total Buy-Back: ' + document.getElementById('total-buyback').textContent);
      summary.push('Total Upgrades (incl. VAT): ' + document.getElementById('total-upgrades').textContent);
      summary.push('Net to Pay: ' + document.getElementById('net-to-pay').textContent);
      try { sessionStorage.setItem('calc_quote', summary.join('\n')); } catch(e){}
      window.location.href = '/pages/contact';
    });

    recalc();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-initialise when the merchant adds or edits the calculator in the theme editor.
  document.addEventListener('shopify:section:load', function(e){
    if (e.target.querySelector('#calc-sell-rows') || e.target.querySelector('#calc-buy-rows')) init();
  });
})();
